import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import ChartBase from '../chartsBase/chart-base'
import MeasurementChart from './Chart';

const mapStateToProps = (state, ownProps) => {
    const { chartName, data } = ownProps;
    const stateSlice = state.measurementChart.charts;
    const chartState = stateSlice[chartName];
    if (!chartState) {
        // use empty
        return {};
    }

    return {
        data: chartState.data,
        processing: chartState.processing,
        xAxisMax: chartState.xAxisMax,
        yAxisMax: chartState.yAxisMax
    };
}

const mapDispatchToProps = {
    dataPreloaded: actions.dataPreloaded,
    clearChart: actions.clearChart,
    axesRangesChanged: actions.axesRangesChanged
};

@connect(mapStateToProps, mapDispatchToProps)
class ChartContainer extends ChartBase {
    static propTypes = {
        // from view
        chartName: PropTypes.string.isRequired,
        options: PropTypes.object.isRequired,
        legendDivId: PropTypes.string,
        // from ajax
        data: PropTypes.object,
        // actions
        dataPreloaded: PropTypes.func.isRequired,
        clearChart: PropTypes.func.isRequired,
        registerRangeReference: PropTypes.func,
        onChartLegendCallback: PropTypes.func,
        axesRangesChanged: PropTypes.func.isRequired,
        height: PropTypes.number,
        onPlotVisibilityChanged: PropTypes.func,
        registerChartReference: PropTypes.func,
        isLongitudinalProfileChart: PropTypes.bool,
        getHiddenPointIds: PropTypes.func,
        getHiddenDatasets: PropTypes.func,
        useLiveDataAccessor: PropTypes.bool
    };

    componentDidMount = () => {
        const {
            processing,
            data,
            dataPreloaded,
            chartName,
            legendDivId} = this.props;

        dataPreloaded(chartName, data);
    }

    legendCallback = (chart) => {
        var text = [];
            text.push('<ul class="' + chart.id + '-legend">');
        for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
            text.push('<li><span style="background-color:' +
                chart.data.datasets[0].backgroundColor[i] + '">');
            if (chart.data.labels[i]) {
                text.push(chart.data.labels[i]);
            }
            text.push('</span></li>');
        }
        text.push('</ul>');
        return text.join("");
    }

    onAxesRangesChanged = scaling => {
        const { chartName, axesRangesChanged, options: { scalingControls: { saveState } } } = this.props;
        const {
            horizontalAxisMin,
            horizontalAxisMax,
            verticalAxisMin,
            verticalAxisMax } = scaling;

        if (saveState) {
            axesRangesChanged(
                chartName,
                horizontalAxisMin,
                horizontalAxisMax,
                verticalAxisMin,
                verticalAxisMax);
        }

    }

    renderChart = () => {
        const {
            options,
            data,
            height,
            registerRangeReference,
            registerChartReference,
            onPlotVisibilityChanged,
            isLongitudinalProfileChart,
            legendDivId,
            getHiddenPointIds,
            getHiddenDatasets,
            yParameterTypeIds,
            profileId,
            useLiveDataAccessor
        } = this.props;
        return (
            <MeasurementChart
                onRangeChanged={this.onAxesRangesChanged}
                onChartLegendCallback={this.legendCallback}
                options={options}
                data={data}
                registerRangeReference={registerRangeReference}
                registerChartReference={registerChartReference}
                onPlotVisibilityChanged={onPlotVisibilityChanged}
                isLongitudinalProfileChart={isLongitudinalProfileChart}
                height={height}
                legendDivId={legendDivId}
                getHiddenPointIds={getHiddenPointIds}
                getHiddenDatasets={getHiddenDatasets}
                yParameterTypeIds={yParameterTypeIds}
                profileId={profileId}
                useLiveDataAccessor={useLiveDataAccessor}
            />
        );
    }

    render = () => {
        const { processing } = this.props;

        return (
            <div className="MeasurementChartContainer">
                {processing ? this.progressLoader() : this.renderChart()}
            </div>);
    }

    componentWillUnmount = () => {
        const { chartName, clearChart } = this.props;
        clearChart(chartName);
    }
}

export default ChartContainer;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart/chart-container.js